import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-hot-toast';
import { postApi } from '../../ApiServices/api';
import { apiEndPoints } from '../../ApiServices/config';
import {
  personalServiceAddToCart,
  personalServiceClearCart,
  personalServiceRemoveFromCart,
  personalServiceUpdateCart
} from '../../actions/index';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { UserContext } from '../../context/UserContext';
import { TempleConfigContext } from '../../context/TempleConfigContext';
import { useContext } from 'react';
dayjs.extend(utc);

export const usePersonalServicesCart = () => {
  const { user } = useContext(UserContext);
  const { config } = useContext(TempleConfigContext);
  const [totalAmount, setTotalAmount] = useState(0);
  const [expanded, setExpanded] = useState({});
  const [selectedDate, setSelectedDate] = useState({});
  const [caterings, setCaterings] = useState({});
  const [no_of_attendees, setNoOfAttendess] = useState({});
  const [rentals, setRentals] = useState({});
  const isDevoteeLoggedIn = !!localStorage.getItem('token');
  const cartArr = useSelector((state) => state.personalServiceCartArr);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { control } = useForm({});
  const serivceType = 'personalServices';
  const bookingType = 'request';
  const validateItem = async (itemType, item) => {
    if (item.booking_config === 'Online booking not available call temple to book') {
      const response = await postApi(apiEndPoints.getBookingConfigByTitle, {
        title: item.booking_config
      });
      toast.error(response.data.data.data.message);
      return false;
    } else if (no_of_attendees[item?._id] === undefined || no_of_attendees[item?._id] === null) {
      toast.error('Please select number of attendees.');
      return false;
    } else if (Number(no_of_attendees[item?._id]) > Number(config?.puja_attendees_capacity) && !rentals[item?._id]) {
      toast.error('Please book select rentals.');
      return false;
    } else if (!selectedDate[item._id]) {
      toast.error('Please select a date for the Puja.');
      return false;
    } else {
      return true;
    }
  };

  const addItem = async (itemType, item) => {
    if (selectedDate[item._id]) {
      const existingCartItem = cartArr.find((cartItem) => cartItem._id === item._id && cartItem.selectedDate === selectedDate[item._id]);

      if (existingCartItem) {
        const updatedItem = {
          ...existingCartItem,
          type_id: 1,
          quantity: 1,
          catering: caterings[item?._id] ? true : false,
          selectedDate: selectedDate[item._id],
          rentals: rentals[item?._id],
          no_of_attendees: no_of_attendees[item?._id]
        };
        dispatch(personalServiceUpdateCart(updatedItem));
        toast.success('Your puja/donation has been successfully updated.');
      } else {
        const newItem = {
          ...item,
          type_id: 1,
          quantity: 1,
          itemType: itemType,
          catering: caterings[item?._id] ? true : false,
          selectedDate: selectedDate[item?._id],
          rentals: rentals[item?._id],
          no_of_attendees: no_of_attendees[item?._id]
        };

        dispatch(personalServiceAddToCart(newItem));
        toast.success('Your puja has been successfully added to the puja basket.');
      }
    }
  };

  const addSingleItem = async (itemType, item) => {
    if (cartArr?.length > 0) {
      toast.error('Please complete the current service booking before adding a new one.');
    } else {
      const newItem = {
        ...item,
        catering: caterings[item?._id] ? true : false,
        selectedDate: selectedDate[item?._id],
        rentals: rentals[item?._id],
        no_of_attendees: no_of_attendees[item?._id]
      };

      dispatch(personalServiceAddToCart(newItem));
      toast.success('Your puja has been successfully added to the puja basket.');
    }
  };

  const handleChildrenRemove = (item) => {
    dispatch(
      personalServiceRemoveFromCart({
        _id: item._id,
        selectedDate: item.selectedDate
      })
    );
    toast.success('Item removed from the Basket');
  };

  const handleEmptyPoojaBasket = () => {
    dispatch(personalServiceClearCart());
  };

  const handleCheckout = () => {
    if (cartArr.length === 0) {
      toast.error('Puja basket is empty, add services/donations before payment');
    } else {
      if (isDevoteeLoggedIn) {
        navigate(`/${serivceType}/${bookingType}`);
      } else {
        toast.error('Need to login for checkout');
      }
    }
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: newExpanded ? panel : false
    }));
  };

  const createPersonalServiceRequest = async (payload) => {
    try {
      const response = await postApi(apiEndPoints.createPersonalServiceRequest, payload);
      if (response?.status === 201) {
        toast.success(response.data.message);
        return response?.data?.data;
      }
    } catch (error) {
      toast.error('Something Went Wrong');
      return false;
    }
  };

  return {
    control,
    addItem,
    validateItem,
    selectedDate,
    setSelectedDate,
    cartArr,
    totalAmount,
    setTotalAmount,
    expanded,
    setExpanded,
    handleChildrenRemove,
    handleEmptyPoojaBasket,
    handleCheckout,
    handleChange,
    caterings,
    setCaterings,
    no_of_attendees,
    setNoOfAttendess,
    rentals,
    setRentals,
    createPersonalServiceRequest,
    addSingleItem
  };
};
